import { createContext, useContext, useEffect, useReducer, useState } from "react";

import axios, { axiosClient } from "../../api/axios";
import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities"

export const UserIndexContext = createContext({});

const listUsers_InitialState = {

    elements: [],
    status: STATUS_NOT_LOADED,
    filter: {
        name: null,
        reference: null,
        limit: 20,
        page: 1,
    },
    rows: 0,
};

const Create_Edit_UserItem_InitialState = {
    id: 0,
    name: "",
    email: "",
    password: "",
};


export const UserIndexProvider = ({ children }) => {

    const [listUsersState, setlistUsersState] = useState(listUsers_InitialState);
    const [createEditUserItemFormState, setcreateEditUserItemFormState] = useState(Create_Edit_UserItem_InitialState);
    const [for_Edit, setfor_Edit] = useState(false);
    const [for_View_Pass, setfor_View_Pass] = useState(false);


    const setFieldFormUser = (value, field) => {
        setcreateEditUserItemFormState({
            ...createEditUserItemFormState,
            [field]: value
        })
    };

    const goToUserEdit = (user_id)=>{
        setfor_Edit(true);
        let selectUserItem = listUsersState.elements.filter((user) => user.id == user_id);
        setcreateEditUserItemFormState(selectUserItem[0]);
      }

    useEffect(() => {
        if (listUsersState.status == STATUS_NOT_LOADED) {
            axios()
                .get(`security/getListUsers`)
                .then(({ data }) => {
                    setlistUsersState({
                        ...listUsersState,
                        elements: data,
                        status: LOADED,
                    });
                })
                .catch((e) => {
                    showTypeErrorFetch(e);
                });
        }

    }, [listUsersState.status]);

    const createUserClick = () => {
        axios()
            .post(`security/createUser`, {
                name: createEditUserItemFormState.name,
                email: createEditUserItemFormState.email,
                password: createEditUserItemFormState.password,
                laboratory_id: 1
            })
            .then(({ data }) => {
                setlistUsersState({
                    ...listUsersState,
                    status: STATUS_NOT_LOADED,
                });
                setcreateEditUserItemFormState(Create_Edit_UserItem_InitialState);
                setfor_Edit(false);
            })
            .catch((e) => {
                showTypeErrorFetch(e);
            });
    }

    const editUserClick = () => {
        axios()
            .put(`security/editUser/${createEditUserItemFormState.id}`, {
                name: createEditUserItemFormState.name,
                email: createEditUserItemFormState.email,
                password: createEditUserItemFormState.password,
                laboratory_id: 1
            })
            .then(({ data }) => {
                setlistUsersState({
                    ...listUsersState,
                    status: STATUS_NOT_LOADED,
                });
                setcreateEditUserItemFormState(Create_Edit_UserItem_InitialState);
                setfor_Edit(false);
            })
            .catch((e) => {
                showTypeErrorFetch(e);
            });
    }

    return (
        <UserIndexContext.Provider
            value={[
                { listUsersState, for_View_Pass, createEditUserItemFormState, for_Edit },
                { createUserClick, setFieldFormUser, setfor_View_Pass, goToUserEdit, editUserClick }
            ]}>
            {children}
        </UserIndexContext.Provider>
    );
}